import React from 'react';
import {  Button, Grid, Typography } from '@mui/material';
import { WSIcons } from '../../commonFunctions/iIcons';  // Assuming you're using WSIcons from your project
import WSIconCard from '../../Components/IconCard/WSIconCard';

const BarFooter: React.FC = () => {
  return (
    <Grid sx={{ backgroundColor: '#333', p: 1 }}>
      <Grid container alignItems="center">
        <Grid item xs={1} display="flex" justifyContent="center">
<WSIcons.GTranslateIcon sx={{color:"white"}}/>          
        </Grid>

        <Grid item xs={10} display="flex" >
        <Button >
            <WSIcons.KeyboardArrowLeftIcon sx={{color:'white'}}/>
            </Button>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "green",
              color: "white",
              minWidth: "120px",
              "&:hover": { backgroundColor: "darkgreen" },
            }}
          >
            Bar Area 1
          </Button>
          <Button
            variant="outlined"
            sx={{
              minWidth: "120px",
              backgroundColor: "White",

            }}
          >
            Bar Area 2
          </Button>
          <Button
            variant="outlined"
            sx={{
              minWidth: "120px",
              backgroundColor: "White",

            }}
          >
            Bar Area 3
          </Button>
          <Button >
           <WSIcons.ChevronRightIcon sx={{color:'white'}}/>
          </Button>
        </Grid>

        {/* Right Icon */}
        <Grid item xs={1} display="flex" justifyContent="center">
        <WSIcons.KeyboardArrowUpIcon sx={{color:'white'}}/>
        <WSIcons.KeyboardArrowDownIcon sx={{color:'white'}}/>

        </Grid>
      </Grid>
    </Grid>
  );
};

export default BarFooter;
